(function($) {

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

var currentInfoWindow = null; 

function new_map( $el ) {
	
  //var center = parseInt($el.attr('data-zoom'));
  //var zoom = parseInt($el.attr('data-zoom'));
  //var zoom = 10;
  var zoom = 10;
  
	// var
	var $markers = $el.find('.marker');
	
	// vars
	var args = {
		zoom: zoom,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP
    },    
		center: new google.maps.LatLng(0, 0),
	  scaleControl: false,
	  scrollwheel: false,
	  navigationControl: false,
	  streetViewControl: false,			
	  mapTypeControl: false,
    
	};
	
	// Map Styles
	var mapStyles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#e4032e"
      },
      {
        "saturation": -55
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#e4032e"
      },
      {
        "saturation": 100
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#e4032e"
      },
      {
        "saturation": -50
      },
      {
        "lightness": 30
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];

		
	// create map	        	
	var map = new google.maps.Map( $el[0], args);
	
	map.setOptions({styles: mapStyles });
	
	// add a markers reference
	map.markers = [];
	
	
	// add markers
	$markers.each(function(){
		
    	add_marker( $(this), map );
		
	});
	
	
	// center map
	//center_map( map );
	center_map( map, zoom );
	$(window).on('shown.bs.collapse', function () {
		center_map( map, zoom );
	});
	
	
	// return
	return map;
	
}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
	var markerColor = $marker.attr('data-marker-color');
var icon = {

    path: "M13.2,0C5.9,0,0,5.9,0,13.2s13.2,24.2,13.2,24.2s13.2-16.9,13.2-24.2S20.5,0,13.2,0z M13.2,18.9c-2.8,0-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1S16,18.9,13.2,18.9z",
    fillColor: markerColor,
    fillOpacity: 1,
    anchor: new google.maps.Point(15,37),
    strokeWeight: 0,
    scale: 1
}
	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map,
		draggable: false,
		animation: google.maps.Animation.DROP,
		title: 'TMT',
		icon: icon
	});

    
	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if ( $marker.html() ) 	{
        
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {
			//infowindow.open( map, marker );
      if (currentInfoWindow != null) {
        currentInfoWindow.close();
      }
      infowindow.open(map, marker);
      currentInfoWindow = infowindow; 
		});
	}
  

}


/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map, zoom ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( zoom );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}

// Map nach erstem Marker zentrieren
function center_map_firstMarker( map, zoom ) {

	// vars
	var bounds = new google.maps.LatLngBounds();
  var markerIteration = 1;

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){
    if (markerIteration < 2) {
  		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
  		bounds.extend( latlng );
      markerIteration++;
    }
	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( zoom );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}



/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

$(document).ready(function(){

	$('.map-tmt').each(function(){

		// create map
		map = new_map( $(this) );

	});

});

})(jQuery);


// WEBPACK FOOTER //
// ./js/parts/googleMap.js